<template>
  <div class="recently-active">
    <div class="recently-active__bg recently-active__bg--1"></div>
    <div class="recently-active__bg recently-active__bg--2"></div>
    <div class="recently-active__title-wrapper">
      <h6 class="recently-active__title">
        Recently active in other courses
      </h6>
      <div class="recently-active__link-wrapper">
        <router-link
          :to="{
            name: 'user-dashboard',
            params: { mode: 'active-courses' },
          }"
          class="recently-active__link"
          >Browse all
          <RightArrows class="recently-active__link--icon" />
        </router-link>
      </div>
    </div>
    <Swiper
      class="recently-active__swiper"
      :parentClass="`recently-active__active-courses`"
      :swiperOptions="swiperOptions"
      :disabled="courses.length <= 4"
      @slide-changed="handleSlideChange"
      @first-slide="handleSlideChange"
    >
      <div
        v-for="(course, i) in courses"
        :key="course.id"
        :class="[
          'swiper-slide',
          'recently-active__tile-wrapper',
          i === 0 &&
            isFirstSlideActive &&
            'recently-active__tile-wrapper--first',
        ]"
      >
        <CourseTile
          class="recently-active__tile--recently-active"
          :isDifficultyShown="true"
          :height="tileHeight"
          :course="course"
          :isFreeTrialUser="false"
        />
      </div>
    </Swiper>
    <div class="recently-active__link-wrapper--bottom">
      <router-link
        :to="{
          name: 'user-dashboard',
          params: { mode: 'active-courses' },
        }"
        class="recently-active__link"
        >View all
      </router-link>
    </div>
  </div>
</template>

<script>
import Swiper from '@/components/layout/Swiper.vue'
import CourseTile from '@/components/layout/CourseTile.vue'
import RightArrows from '@/assets/icons/navigation/right_double_arrows.svg'

export default {
  name: 'RecentlyActive',
  components: {
    Swiper,
    CourseTile,
    RightArrows: { ...RightArrows, name: 'RightArrows' },
  },
  props: {
    courses: {
      type: Array,
      required: true,
    },
    isTablet: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isFirstSlideActive: true,
      swiperOptions: {
        loop: false,
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 'auto',
            spaceBetween: 10,
          },
          500: {
            slidesPerView: 'auto',
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 'auto',
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 'auto',
            spaceBetween: 10,
          },
          1300: {
            slidesPerView: 'auto',
            spaceBetween: 10,
          },
        },
      },
    }
  },
  methods: {
    handleSlideChange(evt) {
      const index = evt?.activeIndex ?? 0
      this.isFirstSlideActive = index === 0
    },
  },
  computed: {
    tileHeight() {
      return this.isTablet ? 269 : 385
    },
  },
}
</script>

<style lang="scss">
.recently-active {
  $this: &;
  padding: 60px 0 43px 0;
  position: relative;
  @include mobile {
    padding: 0 0 43px 0;
  }
  @include tablet {
    padding: 140px 0 79px 0;
    margin-bottom: 15px;
  }
  &__bg {
    position: absolute;
    mix-blend-mode: screen;
    opacity: 0.4;
    z-index: -1;
    filter: blur(300px);
    &--1 {
      width: 542px;
      height: 542px;
      right: -70px;
      top: 1700px;
      background: var(--dark-blue);
      @include mobile {
        display: block;
        width: 970px;
        height: 970px;
        left: -200px;
        top: 0;
        z-index: 0;
      }
      @include tablet {
        left: 50%;
        transform: translateX(-50%);
        top: -190px;
        z-index: -1;
      }
    }
    &--2 {
      z-index: -2;
      width: 542px;
      height: 542px;
      right: -70px;
      top: 1700px;
      background: var(--orange);
      opacity: 0.2;
      @include mobile {
        width: 786px;
        height: 786px;
        right: 1079px;
        top: 1344px;
      }
      @include tablet {
        left: 30%;
        transform: translateX(-50%);
        top: 250px;
      }
    }
  }
  &__title-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 0 25px 0;
    padding: 0 0 0 20px;
    @include tablet {
      padding: 0 0 0 100px;
      margin-bottom: 20px;
    }
  }
  &__title {
    padding: 0;
    margin: 0;
    color: var(--white);
    font-family: var(--font-bold);
    font-size: rem(20);
    line-height: 26px;
    @include mobile {
      font-size: rem(32);
      line-height: 38px;
    }
  }
  &__link-wrapper {
    display: none;
    @include tablet {
      position: static;
      display: flex;
      justify-content: flex-end;
    }
    &--bottom {
      display: flex;
      justify-content: flex-end;
      margin-left: auto;
      padding: 3px 36px 0 0;
      font-size: rem(14);
      line-height: 20px;
      @include tablet {
        display: none;
      }
    }
  }
  &__link {
    color: var(--white);
    font-size: rem(14);
    line-height: 20px;
    position: relative;
    &:hover {
      #{$this}__link--icon {
        right: -40px;
      }
    }
    margin: 25px 0;
    @include mobile {
      font-size: rem(16);
      line-height: 20px;
    }
    @include tablet {
      margin: 0 115px 0 0;
    }
    &--icon {
      fill: var(--white);
      height: rem(12);
      transition: 0.2s all ease;
      position: absolute;
      right: -28px;
      top: 4px;
    }
  }
  &__tile-wrapper {
    position: relative;
    height: 386px;
    max-width: 280px;
    height: 269px;
    transition: 0.5s all ease;
    @include tablet {
      height: 386px;
      min-width: 400px;
    }
    &--first {
      margin: 0 0 0 20px;
      @include tablet {
        margin: 0 0 0 100px;
      }
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    height: 269px;
    @include tablet {
      height: 386px;
    }
  }
  &__tile--recently-active {
    @include tablet {
      padding: 20px 10px;
      box-sizing: border-box;
    }
  }
  &__swiper {
    mask-image: linear-gradient(
      to right,
      transparent 0%,
      #030303 7%,
      #030303 90%,
      transparent 100%
    );
  }
}
</style>
